import React from 'react';
import { createGlobalStyle } from 'styled-components';

const JspreadsheetOverrideStyles = createGlobalStyle`
  .theme {
    // Jspreadsheet Theme Vars
    --header_color: var(--pf-primary-color-200);
    --header_color_highlighted: var(--pf-white-color);
    --header_background: var(--pf-primary-color-950);
    --header_background_highlighted: var(--pf-secondary-color-700);
    --content_color: var(--pf-white-color);
    --content_color_highlighted: red;
    --content_background: var(--pf-primary-color-900);
    --content_background_highlighted: red;
    --menu_background: var(--pf-primary-color-600);
    --menu_background_highlighted: var(--pf-primary-color-500);
    --menu_color: var(--pf-white-color);
    --menu_color_highlighted: var(--pf-white-color);
    --menu_box_shadow: unset;
    --border_color: var(--pf-tertiary-color-600);
    --border_color_highlighted: var(--pf-secondary-color-900);
    --content_color: var(--pf-white-color);
    --cursor: var(--pf-secondary-color-900);
    --active_color: red;

    // Other Jspreadsheet Style Overrides
    .jss { 
      background-color: var(--pf-primary-color-950);
      margin: 0;

      .jss_header {          
        font-size: 14px; 
        font-weight: 600;
        line-height: 20px;  
        text-align: center;
      }

      tr { 
        td[data-role='cell'] {
          text-align: left;
        }
      }
    }
 
    .jss_input.jss_focus {
      background-color: var(--pf-secondary-color-900);
      border: var(--pf-border-md) solid var(--pf-secondary-color-500); 
      color: var(--pf-white-color);
    }

    .jss_border_main {
      background-color: var(--pf-secondary-color-900);
      border: var(--pf-border-md) solid var(--pf-secondary-color-500);
      color: var(--pf-white-color);
    }
  }
`;

export const JspreadsheetOverrides = () => {
  return <JspreadsheetOverrideStyles />;
};
